<template>
  <transition name="fade">
    <div class="ui-video-controler-wrapper" v-show="value" @click.stop="() => {}" @touchmove="progressTouchmove">
      <div class="left">
        <div class="btn btn-mute" :class="isMuted ? 'mute' : ''" @click="toggleMute"></div>
      </div>
      <div class="middle">
        <div class="progress-wrapper">
          <div class="progress-time current">{{ currentTime | resolveTime }}</div>
          <div class="progress-bar-container" @click.capture="handleToggleProgress" :ref="`videoCtrlBar_${videoKey}`">
            <div class="progress-bar-wrapper" :ref="`videoCtrl_${videoKey}`">
              <div class="progress-active-bar-wrapper">
                <div
                  class="progress-active-bar"
                  :style="{
                    transform: `scaleX(${progressBarScale})`,
                    transitionDuration: `${progressBar.transitionDuration}ms`
                  }"
                ></div>
              </div>
            </div>
            <div
              class="ball-wrapper"
              @touchstart="progressTouchstart"
              @touchend="progressTouchend"
              :style="{
                transform: `translate3d(${progressBallTranslateX}px, 0, 0)`,
                transitionDuration: `${progressBar.transitionDuration}ms`
              }"
            >
              <i class="progress-ball"></i>
            </div>
          </div>
          <div class="progress-time total">{{ totalTime | resolveTime }}</div>
        </div>
      </div>
      <div class="right">
        <div class="btn btn-fullscreen" @click="handleFullscreen"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import getTimeFromSec from "./utils/getTimeFromSec"

export default {
  name: "uiVideoControler",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: [Number, String],
      default: 0
    },
    totalTime: {
      type: [Number, String],
      default: 0
    },
    isMuted: {
      type: Boolean,
      default: false
    },
    progressBarScale: {
      type: [Number, String],
      default: 0
    },
    videoKey: {
      type: String,
      default: ""
    }
  },
  filters: {
    resolveTime(time) {
      if (!time) return "00:00"
      return getTimeFromSec(time)
    }
  },
  data() {
    return {
      progressBar: {
        width: 0,
        transitionDuration: 200
      }
    }
  },
  methods: {
    handleFullscreen() {
      this.$emit("fullscreen")
    },
    initProgress() {
      const key = `videoCtrl_${this.videoKey}`
      const barDom = this.$refs[key]
      this.progressBar.width = barDom.offsetWidth
    },
    toggleMute() {
      this.$emit("toggleMute", !this.isMuted)
    },
    progressTouchstart(e) {
      e.preventDefault()
      e.stopPropagation()
      this.progressBar.transitionDuration = 0
      this.hasTouch = true
      this.$emit("touchstart", e)
      this.progressWidth0 = this.progressBallTranslateX
      this.startPageX = e.touches[0].pageX
    },
    progressTouchmove(e) {
      e.preventDefault()
      e.stopPropagation()
      const movePageX = e.changedTouches[0].pageX
      const disPageX = movePageX - this.startPageX
      let moveX = disPageX + parseFloat(this.progressWidth0)
      const isOverProgressBar = moveX >= this.progressBar.width
      const isLessThanZero = moveX <= 0
      if (isOverProgressBar) {
        moveX = this.progressBar.width
      }
      if (isLessThanZero) {
        moveX = 0
      }
      this.scaleX = moveX / this.progressBar.width
      this.$emit("updateProgress", this.scaleX)
    },
    progressTouchend(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit("touchend", e)
      this.$emit("updatePlayProgress")
      this.progressBar.transitionDuration = 200
    },
    handleToggleProgress(e) {
      const progressBarKey = `videoCtrlBar_${this.videoKey}`
      const progressBar = this.$refs[progressBarKey]
      const offsetWidth = progressBar.offsetWidth
      const pageLeft = progressBar.getBoundingClientRect().left
      const pageX = e.pageX
      const dis = pageX - pageLeft
      const scaleX = dis / offsetWidth
      this.$emit("toggleProgress", scaleX)
    }
  },
  computed: {
    progressBallTranslateX() {
      return this.progressBarScale * this.progressBar.width
    }
  },
  watch: {
    value(newVal) {
      if (newVal && !this.progressBar.width) {
        this.$nextTick(() => {
          this.initProgress()
        })
      }
    }
  },
  mounted() {
    this.initProgress()
  }
}
</script>

<style lang="scss" scoped>
.ui-video-controler-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translate3d(0, 0, 0);
  height: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  padding: 0 0.3rem;
  .left {
    flex: none;
    .btn-mute {
      width: 0.4rem;
      height: 0.4rem;
      background: url("./images/icon_sound.png") no-repeat center;
      background-size: 100%;
      &.mute {
        background: url("./images/icon_silence.png") no-repeat center;
        background-size: 100%;
      }
    }
  }
  .middle {
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    line-height: 0.34rem;
    color: #ffffff;
    letter-spacing: 0;
    margin: 0 0.3rem;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .progress-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .progress-time {
      width: 0.84rem;
      text-align: left;
      flex: none;
      &.total {
        text-align: right;
      }
    }
    .progress-bar-container {
      height: 0.48rem;
      flex: 1;
      position: relative;
      display: flex;
      align-items: center;
      .progress-bar-wrapper {
        flex: 1;
        height: 0.04rem;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 0.03rem;
        position: relative;
        .progress-active-bar-wrapper {
          height: 100%;
          border-radius: 0.03rem;
          overflow: hidden;
          .progress-active-bar {
            background-image: linear-gradient(-270deg, #ff0d00 0%, #ff8400 100%);
            border-radius: 0.03rem;
            transform-origin: 0 50%;
            transform: scaleX(0.3);
            transition: all 0.2s;
            position: relative;
            height: 100%;
          }
        }
      }
      .ball-wrapper {
        width: 0.48rem;
        height: 0.48rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: -0.24rem;
        transition: all 0.2s;
        .progress-ball {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #ffffff;
          box-sizing: content-box;
          box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  .right {
    flex: none;
    .btn-fullscreen {
      width: 0.34rem;
      height: 0.34rem;
      background: url("./images/icon_full.png") no-repeat center;
      background-size: 100%;
    }
  }
}
.fade-enter,
.fade-leave-to {
  transform: translate3d(0, 100%, 0);
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
